// Lazy loading for images
import 'lazysizes';
import moment from 'moment';
import './landing-main/utils.js';
import './landing-main/sliders.js';
import './landing-main/banner.js';
import './landing-main/curators-carousel.js';
import './landing-main/header.js';
import './landing-main/reviews.js';
import './landing-main/intercom.js';
import './landing-main/footer.js';
import './landing-main/adriver.js';

// Initialize GDPR cookie popup
window.moment = moment;

(function (document) {
  function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
      // eslint-disable-next-line no-useless-escape
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ));

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, options) {
    if (!options) options = {};

    options.path = '/';

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    for (const optionKey in options) {
      updatedCookie += `; ${optionKey}`;

      const optionValue = options[optionKey];

      if (optionValue !== true) {
        updatedCookie += `=${optionValue}`;
      }
    }

    document.cookie = updatedCookie;
  }

  const gdprTemplate = `\
        <div id="y__gdpr__container">\
            <div id="y__modal" style="visibility: hidden;" class="y__anim">\
                <h3 id="y__gdpr__title">Мы используем cookie 🍪</h3>\
                <p id="y__gdpr__text">\
                    Совместное использование файлов cookie помогает улучшить функциональность сайта и оптимизировать ваш опыт.
                    Просматривая этот сайт, вы соглашаетесь с нашей <a target="_blank" href="/personaldata">политикой конфиденциальности</a>\
                </p>\
                <div id="y__gdpr__btns">\
                    <button id="y__gdpr__accept__btn" type="button" class="_btn-medium _btn-base-primary">Ясно</button>\
                </div>\
            </div>\
        </div>`;

  function createWindow() {
    const div = document.createElement('div');

    div.className = 'y-gdpr';
    div.innerHTML = gdprTemplate;
    document.body.appendChild(div);

    return div;
  }

  function setYasnoGDPR() {
    setCookie('yasno-gdpr', 'accept', {
      expires: 'Tue, 19 Jan 2038 03:14:07 GMT',
      secure: true,
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Показываем popup если пользователь еще не согласился с cookies
    if (!getCookie('yasno-gdpr')) {
      const div = createWindow();
      const modal = div.querySelector('#y__modal');

      modal.classList.add('y__show');

      div.querySelector('#y__gdpr__accept__btn').addEventListener('click', () => {
        setYasnoGDPR();
        modal.classList.remove('y__show');
      });

      // Устанавливаем таймер первого показа popup
      if (!getCookie('yasno-gdpr-timer')) {
        const timer = window.moment().toISOString();

        setCookie('yasno-gdpr-timer', timer, {
          expires: 'Tue, 19 Jan 2038 03:14:07 GMT',
          secure: true,
        });
      }
    }

    // Автоматически принимаем cookies если прошло больше 5 минут с первого показа
    if (getCookie('yasno-gdpr-timer') && !getCookie('yasno-gdpr')) {
      const modal = document.querySelector('#y__modal');
      const timer = window.moment(getCookie('yasno-gdpr-timer'));
      const now = window.moment();
      const min = now.diff(timer.format()) / 60000;

      // Автоматически принимаем если прошло 5+ минут
      if (min >= 5) {
        setYasnoGDPR();

        if (modal) modal.classList.remove('y__show');
      }
    }
  });
}(document));
